(() => {
  if (window.rsCamcorderOfferInstalled) return;
  window.rsCamcorderOfferInstalled = true;
  const selectedVariant = form => form.querySelector('[data-rs-variant-option]:checked');
  const syncVariant = (form, {showMedia = false, updateUrl = false} = {}) => {
    const option = selectedVariant(form);
    if (!option) return;
    const analyticsVariant = form.querySelector('input[name="id"][disabled]');
    if (analyticsVariant) analyticsVariant.value = option.value;
    const selectedColor = form.querySelector('[data-rs-selected-color]');
    if (selectedColor) selectedColor.textContent = option.dataset.rsColor;
    const locked = ['submitting', 'uncertain'].includes(form.dataset.rsOfferState);
    form.querySelector('[type="submit"]').disabled = locked || option.dataset.rsAvailable !== 'true';
    if (showMedia && option.dataset.rsMediaId) {
      const gallery = form.closest('.rs-reference')?.querySelector('.rs-reference-gallery');
      const thumbnail = [...(gallery?.querySelectorAll('[data-rs-thumb][data-rs-media-id]') || [])]
        .find(item => item.dataset.rsMediaId === option.dataset.rsMediaId);
      if (thumbnail) thumbnail.click();
    }
    if (updateUrl) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState(window.history.state, '', url);
    }
  };
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-rs-variant-option]')) return;
    const form = event.target.closest('.rs-camcorder-form');
    if (!form || ['submitting', 'uncertain'].includes(form.dataset.rsOfferState)) return;
    syncVariant(form, {showMedia: true, updateUrl: true});
  });
  const initializeVariants = () => {
    document.querySelectorAll('.rs-camcorder-form').forEach(form => {
      syncVariant(form, {showMedia: true});
    });
  };
  if (document.readyState !== 'complete') document.addEventListener('DOMContentLoaded', initializeVariants, {once: true});
  else initializeVariants();
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.rs-camcorder-form');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    if (button.disabled) return;
    const error = form.querySelector('[role="alert"]');
    const label = form.querySelector('[data-rs-buy-label]');
    const originalLabel = label.textContent;
    const cartReview = form.querySelector('[data-rs-cart-review]');
    const colorPicker = form.querySelector('[data-rs-color-picker]');
    const root = window.Shopify?.routes?.root || '/';
    const attempt = `camcorder-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    let canRetry = true;
    const data = new FormData(form);
    const items = [0, 1, 2, 3].map(index => ({
      id: data.get(`items[${index}][id]`), quantity: 1,
      properties: {_retroshot_offer: index ? 'camcorder-gift' : 'camcorder', _retroshot_offer_group: attempt}
    }));
    if (items.some(item => !/^\d+$/.test(item.id || ''))) {
      error.textContent = form.dataset.error;
      error.hidden = false;
      return;
    }
    form.dataset.rsOfferState = 'submitting';
    if (colorPicker) colorPicker.disabled = true;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    label.textContent = form.dataset.loading;
    error.hidden = true;
    if (cartReview) cartReview.hidden = true;
    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const body = {items};
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map(section => section.id);
      body.sections_url = window.location.pathname;
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(button);
    }
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify(body)
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || form.dataset.error);
      if (result.sections && cart && typeof cart.renderContents === 'function') {
        try {
          cart.classList.remove('is-empty');
          cart.renderContents(result);
        } catch (_) { window.location.assign(`${window.Shopify?.routes?.root || '/'}cart`); }
      } else window.location.assign(`${window.Shopify?.routes?.root || '/'}cart`);
    } catch (exception) {
      // A browser/network or upstream error can be English even on a German page.
      // Keep the existing English behaviour; German uses the translated set message.
      let message = /^de(?:-|$)/i.test(form.dataset.rsLanguage || '')
        ? form.dataset.error
        : (exception.message || form.dataset.error);
      try {
        // An inventory error or a lost response can leave only part of a multi-item add.
        // Reconcile this attempt only; pre-existing cart lines have different properties.
        const check = await fetch(`${root}cart.js`, {headers: {'Accept':'application/json'}});
        if (!check.ok) throw new Error('Cart unavailable');
        const current = await check.json();
        const ownLines = current.items.filter(item => item.properties?._retroshot_offer_group === attempt);
        const complete = items.every(item => ownLines.some(line => String(line.variant_id) === item.id && line.quantity >= 1));
        if (complete) { window.location.assign(`${root}cart`); return; }
        if (ownLines.length) {
          const rollback = await fetch(`${root}cart/update.js`, {
            method: 'POST', headers: {'Content-Type':'application/json', 'Accept':'application/json'},
            body: JSON.stringify({updates: Object.fromEntries(ownLines.map(line => [line.key, 0]))})
          });
          if (!rollback.ok) throw new Error('Cart unavailable');
        }
      } catch (_) {
        canRetry = false;
        message = form.dataset.uncertain;
      }
      error.textContent = message;
      error.hidden = false;
      if (cartReview) cartReview.hidden = false;
    } finally {
      label.textContent = originalLabel;
      form.dataset.rsOfferState = canRetry ? 'idle' : 'uncertain';
      if (colorPicker) colorPicker.disabled = !canRetry;
      button.disabled = !canRetry;
      syncVariant(form);
      button.removeAttribute('aria-busy');
    }
  });
  document.addEventListener('click', (event) => {
    const play = event.target.closest('.rs-camcorder-film-play');
    if (!play) return;
    const video = play.parentElement.querySelector('video');
    if (video) video.play().catch(() => { play.hidden = false; });
  });
  document.addEventListener('ended', (event) => {
    const play = event.target.parentElement?.querySelector('.rs-camcorder-film-play');
    if (play) play.hidden = false;
  }, true);
  // Manual gallery demonstrations are exclusive; silent story loops follow visibility.
  document.addEventListener('play', (event) => {
    if (!(event.target instanceof HTMLVideoElement)) return;
    const play = event.target.parentElement?.querySelector('.rs-camcorder-film-play');
    if (play) play.hidden = true;
    if (event.target.matches('[data-rs-autoplay]')) return;
    const onCamcorderPage = document.querySelector('.rs-camcorder-offer');
    if (!onCamcorderPage) return;
    document.querySelectorAll('video').forEach(video => {
      if (video !== event.target && !video.matches('[data-rs-autoplay]') && !video.paused) video.pause();
    });
  }, true);
})();
